import { useI18n } from 'context/i18n';

type TStarRateProps = {
  allowHalf?: boolean;
  className?: string;
  value?: number;
  character?: React.ReactNode;
  emptyCharacter?: React.ReactNode;
};

const MAX_STARS = 5;

export function StarRate({ allowHalf = false, className, value = 0, character, emptyCharacter }: TStarRateProps) {
  const renderStar = (index: number) => {
    const starValue = index + 1;
    const halfStarValue = index + 0.5;

    // Determine if this star should be filled, half-filled, or empty
    let isFilled = false;
    let isHalfFilled = false;

    if (value >= starValue) {
      isFilled = true;
    } else if (allowHalf && value >= halfStarValue) {
      isHalfFilled = true;
    }

    return (
      <div
        key={`star-${index}`}
        className={'cursor-pointer'}
        style={{
          position: 'relative',
          display: 'inline-block',
        }}
      >
        {/* Empty star background */}
        <div style={{ opacity: 0.2 }}>{emptyCharacter || character}</div>

        {/* Filled star overlay */}
        {isFilled && (
          <div
            style={{
              position: 'absolute',
              top: 0,
              left: 0,
              overflow: 'hidden',
              width: '100%',
            }}
          >
            {character}
          </div>
        )}

        {/* Half-filled star overlay */}
        {isHalfFilled && (
          <div
            style={{
              position: 'absolute',
              top: 0,
              left: 0,
              overflow: 'hidden',
              width: '50%',
            }}
          >
            {character}
          </div>
        )}
      </div>
    );
  };

  return <div className={`inline-block ${className || ''}`}>{Array.from({ length: MAX_STARS }, (_, index) => renderStar(index))}</div>;
}
